import {connect} from 'react-redux';

import {getProduct} from 'topmeteo/general/selectors';

import Base from 'topmeteo/base/components/Base';
import Row from 'topmeteo/general/components/Row';
import Column from 'topmeteo/general/components/Column';

import ContentArea from '../ContentArea';
import MapControls from './MapControls';
import MatrixRow from './MatrixRow';
import AnimationControls from './AnimationControls';
import MobileLoopButton from '../MobileLoopButton';
import ProductLegend from '../ProductLegend';
import SkipButton from '../SkipButton';

const Wrapper = ({type, isPlayable, showMatrix, changeRegion, ...props}) => (
    <div className="matrix-wrapper">
        <Base changeRegion={changeRegion} />
        <ContentArea type={type} {...props} />
        <ProductLegend />
        <MobileLoopButton hidden={isPlayable === false} />
        <MapControls type={type} isPlayable={isPlayable} showMatrix={showMatrix} />
        {showMatrix && <MatrixRow type={type} />}
        <Row>
            <AnimationControls type={type} isPlayable={isPlayable} />
            <Column size={3} className="ctl-skip">
                <SkipButton type={type} />
            </Column>
        </Row>
    </div>
);

const mapStateToProps = state => {
    const {isPlayable} = getProduct(state);
    const {showMatrix} = state;

    return {
        isPlayable,
        showMatrix,
    };
};

export default connect(mapStateToProps)(Wrapper);
